module.exports = __webpack_public_path__ + "img/waring.3c5ee564.png";